import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import template from './palettePicker.jsx';
import compose from '../../hoc/compose';
import * as colorUtil from '../../util/color';
import displayNames from '../displayNames';
import PALETTE_PRESETS from './palettePickerPresets.json';

var PalettePicker = /*#__PURE__*/function (_React$Component) {
  _inherits(PalettePicker, _React$Component);

  var _super = _createSuper(PalettePicker);

  function PalettePicker(props) {
    var _this;

    _classCallCheck(this, PalettePicker);

    _this = _super.call(this, props);

    _this.getPaletteMainColors = function (palette) {
      return palette.map(function (colorSet) {
        return colorSet[2];
      });
    }; // TODO: consider something cheaper performance-wise


    _this.isSelectedPalette = function (palette) {
      return _.isEqual(palette, _this.props.value);
    };

    _this.isLightColor = function (color) {
      return _(color).thru(colorUtil.hexToHsb).thru(colorUtil.getDistanceToWhite).value() < 3;
    };

    return _this;
  }

  _createClass(PalettePicker, [{
    key: "render",
    value: function render() {
      return template.call(this);
    }
  }]);

  return PalettePicker;
}(React.Component);

PalettePicker.displayName = displayNames.PALETTE_PICKER;
PalettePicker.propTypes = {
  palettePresets: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))),
  onChange: PropTypes.func,
  onPaletteEnter: PropTypes.func,
  onPaletteLeave: PropTypes.func,
  value: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))
};
PalettePicker.defaultProps = {
  palettePresets: PALETTE_PRESETS,
  onPaletteEnter: _.noop,
  onPaletteLeave: _.noop
};
export default compose(PalettePicker);